import * as React from 'react'
import MUIDialogTitle from '@mui/material/DialogTitle'

const DialogTitle = (props) => <MUIDialogTitle {...props} />

export default DialogTitle
